import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button, Form, Alert } from "react-bootstrap";
import { Card } from "shards-react";
import swal from "sweetalert2";
import { EntypoMinus, EntypoPlus } from "react-entypo-icons";
import { primaryColor } from "../../config/colors";
import { strings } from "../../localization";
import "./FoodSummary.css";
import {
  displayToast,
  formateNumber,
  getFoodDataFromStorage,
  getReferenceOrderIdFromStorage,
  getTipValueFromStorage,
  KLAP_SCRIPT_URL,
  navigatePage,
  ROUTE_PREFIX,
  setFoodDataInStorage,
  setKlapOrderIdInStorage,
  setReferenceOrderIdInStorage,
  setTipValueInStorage,
  TABLE_ID,
  ToastPosition,
  ToastStatus,
} from "../../config";
import RestaurantFoodItemDetailDialog from "../food_selection/RestaurantFoodItemDetailDialog";
import Header from "../../components/Header";
import Navbar from "../../components/navbar/Navbar";
import { withRouter } from "react-router-dom";
import { createOrder } from "../../api/ApiServices";
import { ToastContainer } from "react-toastify";
window.Swal = swal;

const OrderSummary = ({ match, location, history }) => {
  console.log("match", match);
  console.log("location", location);
  console.log("history", history);

  // Path params
  const { restaurantName } = match.params || {};
  console.log("DEBUG past order page in restaurantName", restaurantName);

  // Query params
  const queryParams = new URLSearchParams(location.search);
  const referenceId = queryParams.get("referenceId");
  const orderId = queryParams.get("orderId");
  console.log("referenceId", referenceId);
  console.log("orderId", orderId);

  const [foodItems, setFoodItems] = useState([]);
  const foodItemsRef = useRef([]);
  const [showFoodDetailDialog, setShowFoodDetailDialog] = useState(false);
  const [selectedFoodItem, setSelectedFoodItem] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [tipEnabled, setTipEnabled] = useState(false);
  const tipEnabledRef = useRef(false);
  const [totalPrice, setTotalPrice] = useState("0");
  const [tipAmount, setTipAmount] = useState("0");
  const [isPaymentBtnLoading, setIsPaymentBtnLoading] = useState(false);
  const [showPaymentFailureMessage, setShowPaymentFailureMessage] = useState(
    true
  );
  const [hasOrderChanged, setHasOrderChanged] = useState(false);
  console.log("🚀 ~ OrderSummary ~ hasOrderChanged:", hasOrderChanged);

  // KLAP config
  const [klapLoaded, setKlapLoaded] = useState(false);

  useEffect(() => {
    foodItemsRef.current = foodItems;
  }, [foodItems]);

  useEffect(() => {
    tipEnabledRef.current = tipEnabled;
  }, [tipEnabled]);

  const getPrice = (isInit, foodItemData) => {
    const allFoodData = isInit ? foodItemData : foodItems;
    const subtotal = allFoodData.reduce((categoryAcc, category) => {
      return (
        categoryAcc +
        category.items.reduce(
          (itemAcc, item) => itemAcc + item.price * parseFloat(item.quantity),
          0
        )
      );
    }, 0);
    const tipAmount = tipEnabledRef.current
      ? Math.ceil((subtotal * 10) / 100)
      : 0;
    const totalAmountIncludingTip = Math.ceil(subtotal + tipAmount);
    const formatedSubtotal = parseFloat(totalAmountIncludingTip.toFixed(2));
    const formatedTipAmount = parseFloat(tipAmount.toFixed(2));
    setTipAmount(formatedTipAmount);
    setTotalPrice(formatedSubtotal);
  };

  const getFoodItems = () => {
    const foodItems = getFoodDataFromStorage();
    const isTipEnabled = getTipValueFromStorage();
    if (foodItems) {
      setTipEnabled(isTipEnabled);
      tipEnabledRef.current = isTipEnabled;
      const parsedItems = JSON.parse(foodItems);
      getPrice(true, parsedItems);
      setFoodItems(parsedItems);
      foodItemsRef.current = parsedItems;
    }
  };

  const displayDeleteDialog = () => {
    return swal.fire({
      title: strings.are_you_sure,
      text: strings.delete_item_msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: strings.yes,
      cancelButtonText: strings.yes_cancel,
    });
  };

  const manageItemQuantity = (categoryId, id, isItemQtyIncrement) => {
    let oldFoodList = [...foodItems];
    const matchedCategory = oldFoodList.find(
      (foodItem) => foodItem._id == categoryId
    );
    if (matchedCategory) {
      const foodItems = matchedCategory.items;
      const matchedFoodItem = foodItems.find(
        (foodItem) => foodItem.itemID === id
      );
      if (matchedFoodItem) {
        let parsedQty = parseInt(matchedFoodItem.quantity) || 0;
        let tempQty = parsedQty;
        if (isItemQtyIncrement) {
          parsedQty++;
          matchedFoodItem.quantity = parsedQty.toString();
        } else {
          tempQty--;
          if (tempQty < 1) {
            displayDeleteDialog().then((response) => {
              if (response.isConfirmed) {
                oldFoodList = removeFoodItemById(oldFoodList, id);
                storeFoodItemsInStorage(oldFoodList);
                setFoodItems(oldFoodList);
                getPrice(true, oldFoodList);
                setHasOrderChanged(true);
              }
            });
          } else {
            parsedQty--;
            matchedFoodItem.quantity = parsedQty.toString();
            storeFoodItemsInStorage(oldFoodList);
            setFoodItems(oldFoodList);
            getPrice();
            setHasOrderChanged(true);
          }
        }
      }
      if (isItemQtyIncrement) {
        storeFoodItemsInStorage(oldFoodList);
        setFoodItems(oldFoodList);
        getPrice();
        setHasOrderChanged(true);
      }
    }
  };

  const storeFoodItemsInStorage = (foodItems) => {
    setFoodDataInStorage(foodItems);
  };

  const handleQtyInputChanges = (categoryId, id, qty) => {
    const oldFoodList = [...foodItems];
    const matchedCategory = oldFoodList.find(
      (foodItem) => foodItem._id == categoryId
    );
    if (matchedCategory) {
      const foodItems = matchedCategory.items;
      const matchedFoodItem = foodItems.find(
        (foodItem) => foodItem.itemID === id
      );
      if (matchedFoodItem) {
        let parsedQty = parseInt(qty) || 0;
        matchedFoodItem.quantity = parsedQty.toString();
      }
      storeFoodItemsInStorage(foodItems);
      setFoodItems(oldFoodList);
      setHasOrderChanged(true);
    }
  };

  const removeFoodItemById = (foodData, itemId) => {
    return foodData
      .map((category) => {
        const updatedItems = category.items.filter(
          (item) => item.itemID !== itemId
        );

        return {
          ...category,
          items: updatedItems,
        };
      })
      .filter((category) => category.items.length > 0);
  };

  const onConfirmPressed = (item, categoryId) => {
    let oldFoodList = [...foodItems];
    const matchedCategory = oldFoodList.find(
      (foodItem) => foodItem._id == categoryId
    );
    if (matchedCategory) {
      const foodItems = matchedCategory.items;
      const matchedFoodItem = foodItems.find(
        (foodItem) => foodItem.itemID === item.itemID
      );
      if (matchedFoodItem) {
        if (item.quantity == 0) {
          setShowFoodDetailDialog(false);
          displayDeleteDialog().then((response) => {
            if (response.isConfirmed) {
              oldFoodList = removeFoodItemById(oldFoodList, item.itemID);
              setHasOrderChanged(true);
            }
            if (response.isDismissed) {
              matchedFoodItem.quantity = 1;
              matchedFoodItem.note = item.note || "";
            }
            setFoodItems(oldFoodList);
            storeFoodItemsInStorage(oldFoodList);
          });
        } else {
          matchedFoodItem.quantity = item.quantity || 0;
          matchedFoodItem.note = item.note || "";
          setFoodItems(oldFoodList);
          setShowFoodDetailDialog(false);
          storeFoodItemsInStorage(oldFoodList);
        }
      }
    }
  };

  const onBackButtonClicked = () => {
    navigatePage(`/${ROUTE_PREFIX}${restaurantName}/food-selection`);
  };

  const onClickMakePaymentButton = () => {
    const referenceIdFromStorage = getReferenceOrderIdFromStorage();
    setIsPaymentBtnLoading(true);
    // No referenceId, call createOrder API
    let addedFoodItems = foodItems.map((category) => category.items).flat();
    const updatedFoodItems = addedFoodItems.map((item) => ({
      ...item,
      quantity: parseFloat(item.quantity),
    }));
    const tableId = localStorage.getItem(TABLE_ID);
    const bodyData = {
      dataArray: updatedFoodItems,
      restaurantTableID: tableId,
      propina: {
        percentage: 10,
        amount: parseFloat(tipAmount),
        checked: tipEnabled,
      },
      isPaid: false,
    };

    // If referenceId getting from storage then pass as request data
    if (referenceIdFromStorage) {
      bodyData["draftOrderID"] = referenceIdFromStorage;
    }
    console.log("body data of order creation", bodyData);
    // Order creation API
    createOrder(bodyData)
      .then(async (res) => {
        console.log("Order creation api response status", res.status);
        if (res.status === 200) {
          const parsedData = await res.json();
          console.log("parsedData", parsedData);
          // Handle success response - proceed with payment flow
          const klapOrderID = parsedData.klapOrderID || "";
          setKlapOrderIdInStorage(klapOrderID);
          handlePaymentSuccess(klapOrderID);
        } else {
          const parsedData = await res.json();
          const message = parsedData.message || strings.something_went_wrong;
          displayToast(ToastStatus.ERROR, message);
          setIsPaymentBtnLoading(false);
        }
      })
      .catch((err) => {
        console.log("catch block error while call order create", err);
        displayToast(ToastStatus.ERROR, strings.something_went_wrong);
        setIsPaymentBtnLoading(false);
      });
  };

  // Handle success response from both APIs
  const handlePaymentSuccess = (klapOrderID) => {
    if (klapOrderID && klapOrderID.length > 0) {
      // KLPA payment initiate
      initiateKlapPayment(klapOrderID);
      setIsPaymentBtnLoading(false);
    } else {
      displayToast(ToastStatus.ERROR, strings.something_went_wrong);
      setIsPaymentBtnLoading(false);
    }
  };

  // Trigger checkout when button is clicked
  const initiateKlapPayment = (klapOrderID) => {
    if (klapLoaded && window.KLAP_FLEX) {
      window.KLAP_FLEX.init({
        orderId: klapOrderID, // replace with order_id from Postman response
        useModal: true, // false = embed in #klapSection, true = modal popup
        debug: true,
      });
    } else {
      // alert("Klap SDK not loaded yet. Please wait.");
      console.log("Klap SDK not loaded yet. Please wait.");
      displayToast(
        ToastStatus.ERROR,
        strings.something_went_wrong_while_initiate_payment,
        ToastPosition.BOTTOM_CENTER
      );
    }
  };

  // KLPA initialize
  const initializeKlap = () => {
    const script = document.createElement("script");
    script.src = KLAP_SCRIPT_URL;
    script.async = true;
    script.onload = () => setKlapLoaded(true);
    document.body.appendChild(script);

    // Set reference id and klap order id in local storage when payment got failed
    if (referenceId && orderId) {
      setReferenceOrderIdInStorage(referenceId);
      setKlapOrderIdInStorage(orderId);
    }
  };

  useEffect(() => {
    initializeKlap(); // KLPA initialize
    getFoodItems();
  }, []);

  console.log("order summary page in food items", foodItems);
  return (
    <Container fluid className="p-0 d-flex flex-column vh-100">
      <ToastContainer />
      <Card className="flex-grow-1 d-flex flex-column overflow-hidden shadow-sm radius-0">
        <Navbar />
        {/* 🔝 Page Title */}
        <div className="colHeaderContainer p-0">
          {/* Header component */}
          <div className="bg-primary">
            <Header
              onBackButtonClicked={onBackButtonClicked}
              title={strings.order_summary}
              backButtonExtraStyle={"mb-3 py-2"}
            />
          </div>

          {/* Payment Failure Message */}
          {referenceId && showPaymentFailureMessage && (
            <div className="px-3 py-3">
              <Alert variant="warning" className="mb-0 payment-failure-alert">
                <div className="d-flex align-items-start">
                  <div className="me-2">
                    <i
                      className="fas fa-exclamation-triangle text-warning"
                      style={{ fontSize: "1.2rem" }}
                    ></i>
                  </div>
                  <div className="flex-grow-1">
                    <Alert.Heading className="h6 mb-1 fw-bold">
                      {strings.payment_failed_title}
                    </Alert.Heading>
                    <p className="mb-0 small">
                      {strings.payment_failed_message}
                    </p>
                  </div>
                  <div className="ms-2">
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => setShowPaymentFailureMessage(false)}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: "1rem",
                        opacity: 0.7,
                        cursor: "pointer",
                      }}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </Alert>
            </div>
          )}

          {/* 📊 Column Titles */}
          <Row className="text-muted medium fw-semibold px-2">
            <Col xs={5} md={6}>
              {strings.item}
            </Col>
            <Col xs={3} md={3} className="text-center">
              {strings.price}
            </Col>
            <Col xs={4} md={3} className="text-end qtyContainer">
              {strings.qty}
            </Col>
          </Row>
        </div>
        <div
          className={`colItemsContainer ${
            referenceId && showPaymentFailureMessage
              ? "with-payment-message"
              : ""
          }`}
        >
          {foodItems.map((foodCategory) => {
            const categoryItems = foodCategory.items;
            console.log("categoryItems", categoryItems);
            if (categoryItems && categoryItems.length > 0) {
              console.log("in if condition");
              return categoryItems.map((item) => (
                <Row className="foodItemRowContainer">
                  {/* Column 1: Food Info */}
                  <Col xs={5} md={6}>
                    <div>
                      <strong
                        className="truncate-multiline"
                        style={{ fontWeight: "bold", fontSize: 16 }}
                      >
                        {item.name}
                      </strong>
                      <div className="medium">{item.description}</div>
                      {item.note ? (
                        <div className="d-flex flex-column">
                          <p
                            style={{
                              fontSize: 14,
                              textDecoration: "underline",
                              color: primaryColor,
                              cursor: "pointer",
                              padding: 0,
                              margin: 0,
                            }}
                            onClick={(e) => {
                              setSelectedFoodItem(item);
                              setShowFoodDetailDialog(true);
                            }}
                          >
                            {strings.edit_note}:{" "}
                          </p>
                          <p
                            className="truncate-multiline text-muted small"
                            style={{
                              textDecoration: "none",
                              width: "100%",
                            }}
                          >
                            {item.note}
                          </p>
                        </div>
                      ) : (
                        <p
                          style={{
                            fontSize: 14,
                            textDecoration: "underline",
                            color: primaryColor,
                            cursor: "pointer",
                            width: "fitContent",
                          }}
                          onClick={(e) => {
                            setSelectedFoodItem(item);
                            setSelectedCategoryId(foodCategory._id);
                            setShowFoodDetailDialog(true);
                          }}
                        >
                          {strings.add_note}
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* Column 2: Price */}
                  <Col xs={3} md={3} className="text-center">
                    <strong>
                      {formateNumber(
                        parseFloat((item.price * item.quantity).toFixed(2))
                      )}
                    </strong>
                  </Col>

                  {/* Column 3: Quantity Control */}
                  <Col xs={4} md={3} className="d-flex justify-content-end">
                    <div className="d-flex align-items-center">
                      {item.quantity && item.quantity > 0 ? (
                        <div
                          className="d-flex align-items-center px-2  py-1 border rounded-pill bg-white"
                          style={{
                            flexShrink: 0,
                            minWidth: "100px",
                            maxWidth: "120px",
                            justifyContent: "space-between",
                            cursor: "pointer",
                          }}
                        >
                          <Button
                            variant="link"
                            onClick={() =>
                              manageItemQuantity(foodCategory._id, item.itemID)
                            }
                            className="p-0"
                            style={{
                              border: "none",
                              boxShadow: "none",
                              color: primaryColor,
                            }}
                          >
                            <EntypoMinus />
                          </Button>

                          <Form.Control
                            type="number"
                            value={item.quantity}
                            onChange={(e) => {
                              const value = parseInt(e.target.value, 10);
                              if (!isNaN(value) && value > 0) {
                                handleQtyInputChanges(
                                  foodCategory._id,
                                  item.itemID,
                                  value
                                );
                              }
                            }}
                            min="1"
                            className="text-center no-spinner"
                            style={{
                              width: "40px",
                              border: "none",
                              backgroundColor: primaryColor,
                              color: "white",
                              borderRadius: "6px",
                              padding: "2px 6px",
                              fontSize: "0.85rem",
                            }}
                          />

                          <Button
                            variant="link"
                            onClick={() =>
                              manageItemQuantity(
                                foodCategory._id,
                                item.itemID,
                                true
                              )
                            }
                            className="p-0"
                            style={{
                              border: "none",
                              boxShadow: "none",
                              color: primaryColor,
                            }}
                          >
                            <EntypoPlus />
                          </Button>
                        </div>
                      ) : (
                        <div
                          className="d-flex align-items-center border rounded-pill px-4 py-2"
                          style={{
                            flexShrink: 0,
                            color: "white",
                            cursor: "pointer",
                            backgroundColor: primaryColor,
                          }}
                          onClick={(e) => {
                            manageItemQuantity(
                              foodCategory._id,
                              item.itemID,
                              true
                            );
                          }}
                        >
                          <Button
                            variant="link"
                            className="p-0 d-flex align-items-center text-decoration-none"
                            style={{
                              color: "white",
                            }}
                          >
                            <span>{strings.add_item.toUpperCase()}</span>
                          </Button>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              ));
            } else {
              return <div>No Data</div>;
            }
          })}
        </div>

        <div
          className="position-fixed bottom-0 start-0 end-0"
          style={{ zIndex: 1030 }}
        >
          <div className="px-3 py-2 border-top bg-white">
            <div className="d-flex justify-content-between align-items-center">
              <span className="fw-bold">{strings.add_tip} (10%)</span>
              <Form.Check
                type="switch"
                id="tip-switch"
                checked={tipEnabled}
                onChange={() => {
                  setTipEnabled(!tipEnabled);
                  setTipValueInStorage(!tipEnabled);
                  tipEnabledRef.current = !tipEnabledRef.current;
                  getPrice();
                  setHasOrderChanged(true);
                }}
              />
            </div>
          </div>
          <div className="p-3 border-top bg-white">
            {/* Tip Row (conditionally visible) */}
            {tipEnabled && (
              <Row className="mb-2">
                <Col className="text-start fw-bold">{strings.tip} (10%)</Col>
                <Col className="text-end">
                  {formateNumber(tipAmount ? tipAmount : 0)}
                </Col>
              </Row>
            )}
            <Row className="mb-2">
              <Col className="text-start fw-bold">{strings.total}</Col>
              <Col className="text-end">
                {formateNumber(totalPrice ? totalPrice : 0)}
              </Col>
            </Row>
            {totalPrice !== 0 && (
              <div className="paymentBtnContainer">
                <Button
                  onClick={onClickMakePaymentButton}
                  variant="primary"
                  size="lg"
                  className="paymentBtn"
                >
                  {isPaymentBtnLoading ? (
                    <span
                      className="spinner-border spinner-border-sm mx-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : referenceId ? (
                    strings.retry_payment
                  ) : (
                    strings.make_payment
                  )}
                </Button>
              </div>
            )}
          </div>
        </div>
      </Card>
      {showFoodDetailDialog && (
        <RestaurantFoodItemDetailDialog
          setShowModal={setShowFoodDetailDialog}
          showModal={showFoodDetailDialog}
          foodItem={selectedFoodItem}
          onConfirmPressed={onConfirmPressed}
          categoryId={selectedCategoryId}
        />
      )}
    </Container>
  );
};

export default withRouter(OrderSummary);
